import React, {useEffect, useState} from "react";
import {Route, Switch, useParams} from "react-router-dom";
import { useData } from '../dataContext';
import * as dbServices from "../utils/dbServices";
import MnEditorMain from "./minutes/mnEditorMain";
import CsrSPLMain from "./csr/csrSPLMain";
import MtkProfile from "./mtk/mtkProfile";
import CsrReview from "./csr/csrReview";

//Main Components


     
const styleContainer={
    "paddingLeft": "20px",
    "paddingTop": "10px"
};

const PetrosMain = (props) =>{

    const { updateDataAll } = useData();


    //data download & context save here
    useEffect(() => {
        getData();
    },[])

    const getData = async () =>{
        const temp = await dbServices["getDataAll"]()
        console.log(temp)
        updateDataAll(temp)
    }


    return(
        <div>
            {/* <NavBar/> */}
            <div className="content" style={styleContainer}>
                <Switch>
                    <Route path="/minutes" component={MnEditorMain} />
                    <Route path="/csr/spl" component={CsrSPLMain} />
                    <Route path="/mtk/profile/:id" component = {MtkProfile} />
                    <Route path="/csr/review/:id" component = {CsrReview} />
                    <Route path="/" component={CsrSPLMain} />

                </Switch>
            </div>
        </div>
    )
}


export default PetrosMain;

